export enum TimelineEventSource {
  /**
   * Changed by user interaction events.
   */
  User = 'user',
  /**
   * Changed programmatically.
   */
  Programmatically = 'programmatically',
  /**
   * Changed by the set time function.
   */
  SetTimeMethod = 'setTimeMethod',
}
